<template>
  <div class="accodion_box_cont apay-loose accodion_box_cont-quick">
    <div id="payment" class="payment_selte">
      <div class="payTab v2">
        <div class="about_a-pay top-line">
          <div class="amway-theme radio-type-tooltip">
            <div class="radio-wrapper">
              간편결제
              <div class="toolTip-wrapper toolTip-type02 type-mob-full">
                <button
                  type="button"
                  class="btn-tooltip"
                  :class="classAPayDisplayToolTip"
                  @click="displayAPayToolTip = !displayAPayToolTip"
                >
                  <span class="hidden">안내</span>
                </button>
                <div class="tipCont-wrapper" style="max-width: none">
                  <div
                    class="tooltip-content contFull"
                    :style="styleAPayToolTipDisplay"
                  >
                    <ul class="list-type5">
                      <li>
                        퀵계좌이체와 A-Pay는 계좌 및 신용카드를 등록하여,
                        결제번호 입력만으로 간편하게 결제할 수 있는
                        서비스입니다.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            v-if="displayQuickAccountBilling"
            type="button"
            class="pop_a-pay pop_quick"
            @click="
              openExternalBrowser(
                'https://consumer.tosspayments.com/accountpay/settings'
              )
            "
          >
            퀵계좌 관리
          </button>
        </div>

        <a
          class="apay-text apay-text_new"
          href="https://www.amway.co.kr/notifications/notice/detail?notificationCode=00624609&noticeType=SHOPPING"
          target="_blank"
        >
          <span>
            <template v-if="isAmwayPayAccountVisible">
              <em>퀵계좌이체</em> 또는 <em>A Pay 자동이체</em>로 쉽고 빠르게
              결제하고 <em>PV UP 혜택</em>도 받아보세요.
            </template>
            <template v-else>
              <em>퀵계좌이체</em>로 쉽고 빠르게 결제하고 <em>PV UP 혜택</em>도
              받아보세요.
            </template>
          </span>
        </a>

        <!-- 래핑 추가 -->
        <div class="apay_partner_cont">
          <div class="payTab_button_area">
            <a
              class="payTaba payTab6"
              :class="classQuickAccountBilling"
              @click="selectQuickAccountBilling"
            >
              퀵계좌이체
            </a>
            <a
              class="payTaba payTab3"
              :class="classAmwayPayCreditCard"
              @click="selectAmwayPayCard"
            >
              A Pay 카드 결제
            </a>
            <a
              v-if="isAmwayPayAccountVisible"
              class="payTaba payTab1"
              :class="classAmwayPayAccount"
              @click="selectAmwayPayAccount"
            >
              A Pay 자동이체
            </a>
          </div>

          <div
            class="about_a-pay top-line no-paddings joint-business"
            v-show="displayAmwayPayCreditCard || displayAmwayPayAccount"
            v-if="subName !== ''"
          >
            <div class="amway-theme radio-type-tooltip">
              <div class="radio-wrapper">
                결제하실 사업자 선택
                <!-- 툴팁 -->
                <div
                  class="toolTip-wrapper toolTip-type02 type-mob-full"
                  :class="classBusinessPersonToolTip"
                >
                  <button
                    type="button"
                    class="btn-tooltip"
                    @click="
                      displayBusinessPersonToolTip =
                        !displayBusinessPersonToolTip
                    "
                  >
                    <span class="hidden">안내</span>
                  </button>
                  <div class="tipCont-wrapper" style="max-width: none">
                    <div
                      class="tooltip-content"
                      :style="styleBusinessPersonToolTip"
                    >
                      <p>
                        결제 시 기본으로 설정할 사업자 선택은 마이페이지내 ʻA
                        Pay 결제수단 관리’에서 변경이 가능합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- 툴팁 -->
              </div>
            </div>
          </div>
          <!-- E : 20220929 결제하실 사업자 선택 영역 이동 -->

          <!-- S : 라디오탭 -->
          <div
            class="tab-area-out tab-area-out_new"
            v-show="displayAmwayPayCreditCard || displayAmwayPayAccount"
            v-if="subName !== ''"
          >
            <div class="tab-area_new with50">
              <div class="tab-head" role="tab">
                <input
                  class="amwa-radio on"
                  type="radio"
                  name="apay_partner"
                  id="apay_partner1"
                  @change="updatePartySelection(0)"
                  :checked="selectedParty === 0"
                />
                <label for="apay_partner1" class="focus">
                  <span class="pc"
                    >공동사업자1 (<span class="ellipsis">{{ masterName }}</span
                    >님)</span
                  >
                  <span class="mo"
                    ><span class="ellipsis">{{ masterName }}</span
                    >님</span
                  >
                </label>
              </div>
              <div class="tab-head" v-if="subName !== ''" role="tab">
                <input
                  class="amwa-radio"
                  type="radio"
                  name="apay_partner"
                  id="apay_partner2"
                  @change="updatePartySelection(1)"
                  :checked="selectedParty === 1"
                />
                <label for="apay_partner2" class="focus">
                  <span class="pc"
                    >공동사업자2 (<span class="ellipsis">{{ subName }}</span
                    >님)</span
                  >
                  <span class="mo"
                    ><span class="ellipsis">{{ subName }}</span
                    >님</span
                  >
                </label>
              </div>
            </div>
          </div>

          <div class="apay_partner_subcont">
            <div class="payTab_cont_area radio-type1">
              <!-- AmwayPay 퀵계좌 -->
              <quick-account-billing
                ref="quickAccountBilling"
                v-show="displayQuickAccountBilling"
                @save-data="$emit('save-data')"
              />

              <!-- AmwayPay 카드 -->
              <amway-pay-card
                ref="amwayPayCard"
                v-show="displayAmwayPayCreditCard"
                :amway-pay-cards="amwayPayCards"
              />

              <!-- AmwayPay 계좌 -->
              <amway-pay-account
                v-if="isAmwayPayAccountVisible"
                ref="amwayPayAccount"
                v-show="displayAmwayPayAccount"
                :amway-pay-accounts="amwayPayAccounts"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  AMWAY_PAY_METHODS,
  NORMAL_PAYMENT_METHODS,
  PAYMENT_METHODS,
} from "@/utils/constants";
import { mapGetters } from "vuex";

import QuickAccountBilling from "@/views/composition/payment/QuickAccountBilling";
import AmwayPayAccount from "@/views/composition/payment/AmwayPayAccount";
import AmwayPayCard from "@/views/composition/payment/AmwayPayCard";

export default {
  name: "AmwayPay",
  components: { QuickAccountBilling, AmwayPayCard, AmwayPayAccount },
  props: {
    paymentMethodInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          paymentMethod: PAYMENT_METHODS.NORMAL,
          otherPaymentMethod: NORMAL_PAYMENT_METHODS.TRANSFER,
          amwayPayMethod: AMWAY_PAY_METHODS.ACCOUNT,
        };
      },
    },
    amwayPayMethods: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      selectedParty: "amwaypay/selectedParty",
      masterName: "amwaypay/currentMasterName",
      subName: "amwaypay/currentSubName",
      paymentInfo: "payment/paymentInfo",
    }),
    classQuickAccountBilling() {
      return this.amwayPayOn &&
        this.selectedAmwayPayMethod === AMWAY_PAY_METHODS.QUICK_ACCOUNT
        ? "on"
        : "";
    },
    classAmwayPayAccount() {
      return this.amwayPayOn &&
        this.selectedAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT
        ? "on"
        : "";
    },
    classAmwayPayCreditCard() {
      return this.amwayPayOn &&
        this.selectedAmwayPayMethod === AMWAY_PAY_METHODS.CARD
        ? "on"
        : "";
    },
    classAPayDisplayToolTip() {
      return this.displayAPayToolTip ? "open" : "";
    },
    styleAPayToolTipDisplay() {
      return this.displayAPayToolTip
        ? { display: "block" }
        : { display: "none" };
    },
    amwayPayOn() {
      return this.paymentMethodInfo.paymentMethod === PAYMENT_METHODS.AMWAY_PAY;
    },
    selectedAmwayPayMethod() {
      return this.paymentMethodInfo.amwayPayMethod;
    },
    displayQuickAccountBilling() {
      return (
        this.amwayPayOn &&
        this.selectedAmwayPayMethod === AMWAY_PAY_METHODS.QUICK_ACCOUNT
      );
    },
    displayAmwayPayAccount() {
      return (
        this.amwayPayOn &&
        this.selectedAmwayPayMethod === AMWAY_PAY_METHODS.ACCOUNT
      );
    },
    displayAmwayPayCreditCard() {
      return (
        this.amwayPayOn &&
        this.selectedAmwayPayMethod === AMWAY_PAY_METHODS.CARD
      );
    },
    classBusinessPersonToolTip() {
      return this.displayBusinessPersonToolTip ? "open" : "";
    },
    styleBusinessPersonToolTip() {
      return this.displayBusinessPersonToolTip
        ? { display: "block" }
        : { display: "none" };
    },
    isAmwayPayAccountVisible() {
      const now = new Date();
      const hide = new Date("2026-01-01T00:00:00+09:00");
      return now < hide;
    },
  },
  data() {
    return {
      amwayPayLogo: require("../../../../static/images/a-pay-logo.png"),
      displayAPayToolTip: false,
      amwayPayAccounts: this.amwayPayMethods.accounts,
      amwayPayCards: this.amwayPayMethods.cards,
      displayBusinessPersonToolTip: false,
    };
  },
  methods: {
    selectQuickAccountBilling() {
      this.$emit("update-payment-info", {
        selectedPaymentMethod: PAYMENT_METHODS.AMWAY_PAY,
        selectedAmwayPayMethod: AMWAY_PAY_METHODS.QUICK_ACCOUNT,
      });
    },
    selectAmwayPayAccount() {
      this.$emit("update-payment-info", {
        selectedPaymentMethod: PAYMENT_METHODS.AMWAY_PAY,
        selectedAmwayPayMethod: AMWAY_PAY_METHODS.ACCOUNT,
      });
    },
    selectAmwayPayCard() {
      this.$emit("update-payment-info", {
        selectedPaymentMethod: PAYMENT_METHODS.AMWAY_PAY,
        selectedAmwayPayMethod: AMWAY_PAY_METHODS.CARD,
      });
    },
    updatePartySelection(value = 0) {
      this.$store.commit("amwaypay/updateSelectedParty", value);
      if (this.$refs.amwayPayAccount) {
        this.$refs.amwayPayAccount.activeIndex = 0;
      }
      if (this.$refs.amwayPayCard) {
        this.$refs.amwayPayCard.activeIndex = 0;
      }
    },
    openExternalBrowser: function (urlLink) {
      var userAgent = window.navigator.userAgent.toLowerCase();
      if (/AMWAY_IOS_APP/.test(userAgent)) {
        window.location = "browser:" + urlLink;
      } else if (/AMWAY_ANDROID_APP/.test(userAgent)) {
        window.browser.browserConnect(urlLink);
      } else {
        window.open(urlLink, "_blank");
      }
    },
  },
};
</script>

<style scoped>
</style>
